import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { DetailComparisonService } from '../services/detail-comparison.service';
import { DetailCompareDetails, Action, DetailCompareHeader } from '../objects/CompareObject';
import { WorkspaceService } from '../services/workspace.service';
import { Globals } from '../objects/Globals';
import { WorkflowReturnService } from '../services/workflow-return.service';
import { ContextMenuService, ContextMenuComponent } from 'ngx-contextmenu';
//import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx-js-style';
var ComparisonComponent = /** @class */ (function () {
    function ComparisonComponent(detailComparisonService, globals, workspaceService, workflowReturnService, contextMenuService) {
        this.detailComparisonService = detailComparisonService;
        this.globals = globals;
        this.workspaceService = workspaceService;
        this.workflowReturnService = workflowReturnService;
        this.contextMenuService = contextMenuService;
        this.step = 0;
        this.isBusy = false;
        this.columnsCount = 0;
        this.paramList = [];
        this.columns = [];
        this.hiddenHeaders = [];
        this.compareActions = new EventEmitter();
        this.loadingPopup = new EventEmitter();
        this.hidePopup = new EventEmitter();
    }
    Object.defineProperty(ComparisonComponent.prototype, "setComponentId", {
        set: function (id) {
            this.componentId = id;
            this.getComparisonInfo();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComparisonComponent.prototype, "triggerAction", {
        set: function (action) {
            if (action) {
                this.compareAction(action.ActionName);
            }
        },
        enumerable: true,
        configurable: true
    });
    ComparisonComponent.prototype.ngOnInit = function () {
        document.querySelectorAll("body").item(0).style.position = "relative";
    };
    ComparisonComponent.prototype.ngOnDestroy = function () {
        document.querySelectorAll("body").item(0).style.position = "initial";
    };
    ComparisonComponent.prototype.getComparisonInfo = function () {
        var _this = this;
        this.isBusy = true;
        this.detailComparisonService.getDetailComparisonInfo(this.componentId).subscribe(function (result) {
            _this.isBusy = false;
            _this.originalCompareObject = JSON.parse(result);
            _this.columns = [];
            if (_this.originalCompareObject.Actions) {
                _this.compareActions.emit(_this.originalCompareObject.Actions);
            }
            _this.compareObject = JSON.parse(result);
            _this.formatCompareObject();
            _this.pushColumnsDropdown();
        });
    };
    ComparisonComponent.prototype.pushColumnsDropdown = function () {
        var _this = this;
        this.originalCompareObject.Headers.forEach(function (element) {
            var d = document.createElement('div');
            d.innerHTML = element.HeaderDisplay;
            var displayColm = { Order: element.Order, Name: element.Name, HeaderDisplay: d.innerText, OriginalDisplay: element.HeaderDisplay, isChecked: true };
            _this.columns.push(displayColm);
        });
    };
    ComparisonComponent.prototype.formatCompareObject = function () {
        var _this = this;
        this.sortHeader();
        this.compareObject.Headers = this.compareObject.Headers.slice(0, 4);
        ;
        var i = 0;
        this.compareObject.Headers.forEach(function (header) {
            if (_this.compareObject.Headers.length + 1 == 5) {
                _this.columnsCount = 5;
            }
            else {
                _this.columnsCount = 12 / (_this.compareObject.Headers.length + 1);
            }
        });
    };
    ComparisonComponent.prototype.setStep = function (index, groupName) {
        var _this = this;
        this.step = index;
        this.isBusy = false;
        if (!this.compareObject.Groups.find(function (x) { return x.Name == groupName; }).Data) {
            this.detailComparisonService.getDetailComparisonGroup(this.componentId, groupName).subscribe(function (result) {
                _this.compareObject.Groups.find(function (x) { return x.Name == groupName; }).Data = JSON.parse(result);
                //console.log(this.compareObject);
            });
        }
    };
    ComparisonComponent.prototype.nextStep = function () {
        this.step++;
    };
    ComparisonComponent.prototype.prevStep = function () {
        this.step--;
    };
    ComparisonComponent.prototype.getVisiblePrevious = function (header, first) {
        if (first && this.compareObject.Headers.length > 3) {
            var index = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == header.Name; });
            if (index > -1 && this.originalCompareObject.Headers[index - 1]) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    ComparisonComponent.prototype.getVisibleNext = function (header, last) {
        if (last && this.compareObject.Headers.length > 3) {
            var index = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == header.Name; });
            if (index > -1 && this.originalCompareObject.Headers[index + 1]) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    ComparisonComponent.prototype.nextItem = function () {
        var lastName = this.compareObject.Headers[this.compareObject.Headers.length - 1].Name;
        var lastIndex = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == lastName; });
        if (this.originalCompareObject.Headers[lastIndex + 1]) {
            this.compareObject.Headers.shift();
            this.compareObject.Headers.push(this.originalCompareObject.Headers[lastIndex + 1]);
        }
    };
    ComparisonComponent.prototype.previousItem = function () {
        var firstName = this.compareObject.Headers[0].Name;
        var firstIndex = this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == firstName; });
        if (this.originalCompareObject.Headers[firstIndex - 1]) {
            this.compareObject.Headers.splice(-1, 1);
            this.compareObject.Headers.unshift(this.originalCompareObject.Headers[firstIndex - 1]);
        }
    };
    ComparisonComponent.prototype.onValueChange = function (groupName, propertyDisplay, headerName, value) {
        var param;
        // construct object to prepare for workflow parameter => it is a list of headers, which has a list of all its changed properties 
        if (this.paramList.find(function (x) { return x.name == headerName; })) {
            var existingParam = this.paramList.find(function (x) { return x.name == headerName; });
            if (this.originalCompareObject.Groups.find(function (x) { return x.Name == groupName; }).Type == "SUBDOC") {
                param = { name: propertyDisplay, value: value, group: groupName };
            }
            else {
                param = { name: propertyDisplay, value: value };
            }
            var exists = existingParam.value.findIndex(function (z) { return z.name == propertyDisplay; });
            if (exists > -1) {
                existingParam.value.splice(exists, 1, param);
            }
            else {
                existingParam.value.push(param);
            }
        }
        else {
            var headerArray = [];
            var header;
            header = { name: "DocumentInstanceId", value: headerName }; // this is the identifier for each header, headerName == header id
            if (this.originalCompareObject.Groups.find(function (x) { return x.Name == groupName; }).Type == "SUBDOC") {
                param = { name: propertyDisplay, value: value, group: groupName };
            }
            else {
                param = { name: propertyDisplay, value: value };
            }
            headerArray.push(header);
            headerArray.push(param);
            this.paramList.push({ name: headerName, value: headerArray }); // so param list will contains all the list of header arrays
        }
        //console.log(headerArray);
        //console.log(this.paramList);
        this.detailComparisonService.detailComparisonUpdateValue(this.componentId, groupName, headerName, param).subscribe(function (result) {
            console.log(result);
        });
    };
    ComparisonComponent.prototype.compareAction = function (actionName) {
        var _this = this;
        this.loadingPopup.emit(true);
        var arr = [];
        this.originalCompareObject.Headers.forEach(function (header) {
            if (!header.Name.startsWith("#")) {
                arr.push({ name: 'Name', value: header.Name });
            }
        });
        this.detailComparisonService.detailComparisonAction(this.componentId, actionName, arr).subscribe(function (result) {
            _this.loadingPopup.emit(false);
            if (result) {
                var wf = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(wf);
                switch (wf.RefreshType) {
                    case "self":
                        _this.getComparisonInfo();
                        break;
                    case "parent":
                        _this.isBusy = true;
                        _this.getComparisonInfo();
                        _this.getEPICParent(false, wf.ReturnType);
                        break;
                    case "all":
                        _this.getComparisonInfo();
                        _this.getEPICParent(true, wf.ReturnType);
                        break;
                }
            }
        }, function (error) {
            _this.loadingPopup.emit(false);
        });
    };
    ComparisonComponent.prototype.getEPICParent = function (findAllParent, returnType) {
        var _this = this;
        if (findAllParent) {
            this.workspaceService.getAllParentsEPICId(this.componentId).subscribe(function (result) {
                _this.handlePopup(returnType);
                if (result) {
                    var array = JSON.parse(result);
                    array.forEach(function (id) {
                        _this.workspaceService.setParentId(id);
                    });
                }
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
        else {
            this.workspaceService.getParentEPICId(this.componentId).subscribe(function (result) {
                _this.workspaceService.setParentId(result);
                _this.handlePopup(returnType);
            }, function (error) {
                _this.handlePopup(returnType);
            });
        }
    };
    ComparisonComponent.prototype.handlePopup = function (returnType, isPreview) {
        if (isPreview === void 0) { isPreview = false; }
        if (returnType == 4) {
            this.hidePopup.emit(true);
        }
    };
    ComparisonComponent.prototype.onSelectionChange = function (event) {
        var _this = this;
        this.loadingPopup.emit(true);
        this.detailComparisonService.getFileCompareObject(this.componentId, this.originalCompareObject.CompareDefinition, encodeURIComponent(event.SelectionValue), this.originalCompareObject.ComparingIds).subscribe(function (result) {
            if (result) {
                var command = JSON.parse(result);
                _this.workflowReturnService.handleWorkflowReturn(JSON.parse(result));
                switch (command.RefreshType) {
                    case "self":
                        _this.getComparisonInfo();
                        break;
                }
            }
            _this.loadingPopup.emit(false);
        }, function (error) {
            _this.loadingPopup.emit(false);
        });
    };
    ComparisonComponent.prototype.drop = function (event) {
        var _this = this;
        if (event) {
            if (event.value) {
                if (event.value.Order) {
                    var header = this.compareObject.Headers.find(function (x) { return x.Name == event.value.Name; }); // drag element
                    if (header) {
                        var originalOrder = header.Order;
                        if (this.compareObject.Headers[event.dropIndex - 1]) {
                            var newOrder = this.compareObject.Headers[event.dropIndex - 1].Order;
                            this.compareObject.Headers[event.dropIndex - 1].Order = originalOrder;
                            if (this.originalCompareObject.Headers.find(function (x) { return x.Name == _this.compareObject.Headers[event.dropIndex - 1].Name; })) {
                                this.originalCompareObject.Headers.find(function (x) { return x.Name == _this.compareObject.Headers[event.dropIndex - 1].Name; }).Order = originalOrder;
                            }
                            header.Order = newOrder;
                            this.originalCompareObject.Headers.find(function (x) { return x.Name == event.value.Name; }).Order = newOrder;
                        }
                        this.sortHeader();
                        this.sortOriginalHeader();
                        this.originalCompareObject = Object.assign({}, this.originalCompareObject);
                        this.compareObject = Object.assign({}, this.compareObject);
                    }
                }
            }
        }
    };
    ComparisonComponent.prototype.sortHeader = function () {
        this.compareObject.Headers = this.compareObject.Headers.sort(function (a, b) {
            if (a.Order > b.Order) {
                return 1;
            }
            else if (a.Order < b.Order) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ComparisonComponent.prototype.sortOriginalHeader = function () {
        this.originalCompareObject.Headers = this.originalCompareObject.Headers.sort(function (a, b) {
            if (a.Order > b.Order) {
                return 1;
            }
            else if (a.Order < b.Order) {
                return -1;
            }
            else {
                return 0;
            }
        });
    };
    ComparisonComponent.prototype.onContextMenu = function ($event) {
        if ($event.button == 0) {
            this.contextMenuService.show.next({
                anchorElement: $event.target,
                contextMenu: this.basicMenu,
                event: $event,
                item: ''
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
    };
    ComparisonComponent.prototype.onChange = function (event) {
        var _this = this;
        if (!event.isChecked) {
            var visible = true;
            var header = this.compareObject.Headers.find(function (x) { return x.Name == event.Name; }); // find in visible headers
            if (!header) {
                header = this.originalCompareObject.Headers.find(function (x) { return x.Name == event.Name; }); // find in original headers
                visible = false;
            }
            header["isVisible"] = visible; // this is to know where its from, either from the visible headers, or the original list
            this.hiddenHeaders.push(header);
            if (visible) {
                if (this.compareObject.Headers.length == 4) {
                    var nextHeader = this.originalCompareObject.Headers[this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == _this.compareObject.Headers[_this.compareObject.Headers.length - 1].Name; }) + 1];
                    if (!nextHeader) {
                        nextHeader = this.originalCompareObject.Headers[this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == _this.compareObject.Headers[0].Name; }) - 1];
                    }
                    if (nextHeader) {
                        this.compareObject.Headers.push(nextHeader);
                    }
                }
                this.compareObject.Headers.splice(this.compareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }), 1);
                this.originalCompareObject.Headers.splice(this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }), 1);
            }
            else {
                this.originalCompareObject.Headers.splice(this.originalCompareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }), 1);
            }
        }
        else {
            var newObj = {
                Order: event.Order,
                Name: event.Name,
                HeaderDisplay: event.OriginalDisplay
            };
            var isVisible = this.hiddenHeaders.find(function (x) { return x.Name == event.Name; }).isVisible;
            this.hiddenHeaders.splice(this.hiddenHeaders.findIndex(function (x) { return x.Name == event.Name; }), 1);
            if (isVisible) {
                this.compareObject.Headers.push(newObj);
            }
            else {
                if (this.compareObject.Headers.findIndex(function (x) { return x.Name == event.Name; }) == -1 && this.compareObject.Headers.length < 4) {
                    this.compareObject.Headers.push(newObj);
                }
            }
            var g = this.originalCompareObject.Headers.find(function (x) { return x.Name == newObj.Name; });
            if (!g) {
                this.originalCompareObject.Headers.push(newObj);
            }
        }
        this.formatCompareObject();
        this.sortOriginalHeader();
        this.originalCompareObject = Object.assign({}, this.originalCompareObject);
        this.compareObject = Object.assign({}, this.compareObject);
    };
    ComparisonComponent.prototype.exportToExcel = function () {
        var wsData = [];
        // Add headers
        var headerRow = [
            ''
        ].concat(this.originalCompareObject.Headers.map(function (h) { return h.HeaderDisplay.replace(/<br\s*\/?>/gi, '').replace(/<[^>]+>/g, '').trim(); }));
        wsData.push(headerRow);
        var merges = [];
        var currentRow = 1;
        this.originalCompareObject.Groups.forEach(function (group) {
            wsData.push([group.HeaderDisplay].concat(Array(headerRow.length - 1).fill('')));
            // Merge cells across the entire row (A to last column)
            merges.push({
                s: { r: currentRow, c: 0 },
                e: { r: currentRow, c: headerRow.length - 1 } // end cell
            });
            currentRow++;
            group.Data.forEach(function (row) {
                var filteredRow = Array.isArray(row)
                    ? row.filter(function (_, index) { return index !== 1; })
                    : Object.values(row).filter(function (_, index) { return index !== 1; });
                wsData.push(filteredRow);
                currentRow++;
            });
            // Add spacer row
            wsData.push([''].concat(Array(headerRow.length - 1).fill('')));
            // Merge spacer row
            merges.push({
                s: { r: currentRow, c: 0 },
                e: { r: currentRow, c: headerRow.length - 1 }
            });
            currentRow++;
        });
        // Convert to worksheet
        var worksheet = XLSX.utils.aoa_to_sheet(wsData);
        worksheet['!rows'] = []; // Initialize row heights
        // Set column widths 
        worksheet['!cols'] = headerRow.map(function () { return ({ wpx: 250 }); }); // Set all columns to 250px width
        worksheet['!merges'] = merges;
        // Add borders to all cells
        var headerRange = XLSX.utils.decode_range(worksheet['!ref']); // Get range of the worksheet
        for (var col = headerRange.s.c; col <= headerRange.e.c; col++) {
            var cellAddress = { r: 0, c: col }; // Header row (0 index)
            var cellRef = XLSX.utils.encode_cell(cellAddress);
            if (!worksheet[cellRef])
                worksheet[cellRef] = {}; // Create cell if not present
            // Apply bold and wrap text
            worksheet[cellRef].s = worksheet[cellRef].s || {};
            worksheet[cellRef].s.font = { bold: true }; // Bold the header text
            worksheet[cellRef].s.alignment = { wrapText: true, vertical: 'center', horizontal: 'center' }; // Wrap text and center it
        }
        // Style the group header row (Light gray background)
        merges.forEach(function (merge) {
            // Check if the merged range corresponds to a group header row and it's not a spacer row
            if (merge.s.r > 0) {
                var groupRow = merge.s.r;
                var cellRef = XLSX.utils.encode_cell({ r: groupRow, c: 0 }); // First cell of the merged group header row
                // Check if the row is a spacer row (only empty cells except for the first column)
                if (wsData[groupRow][0] !== '' && !wsData[groupRow].every(function (cell) { return cell === ''; })) {
                    if (!worksheet[cellRef])
                        worksheet[cellRef] = {}; // Create cell if not present
                    worksheet[cellRef].s = worksheet[cellRef].s || {};
                    // Apply light gray background to the merged group header row
                    worksheet[cellRef].s.fill = { fgColor: { rgb: 'D3D3D3' } };
                }
            }
        });
        // Apply wrap text to **all cells** in the worksheet (not just headers)
        var range = XLSX.utils.decode_range(worksheet['!ref']); // Get range of the worksheet
        for (var row = range.s.r; row <= range.e.r; row++) {
            for (var col = range.s.c; col <= range.e.c; col++) {
                var cellAddress = { r: row, c: col };
                var cellRef = XLSX.utils.encode_cell(cellAddress);
                if (!worksheet[cellRef])
                    worksheet[cellRef] = {}; // Create cell if not present
                // Apply wrap text and alignment for all cells
                worksheet[cellRef].s = worksheet[cellRef].s || {};
                worksheet[cellRef].s.alignment = worksheet[cellRef].s.alignment || {};
                worksheet[cellRef].s.alignment.wrapText = true; // Enable wrap text
                if (col !== 0) {
                    worksheet[cellRef].s.alignment.vertical = 'center'; // Vertical alignment
                    worksheet[cellRef].s.alignment.horizontal = 'center'; // Horizontal alignment
                }
            }
        }
        // Set borders for all cells
        for (var row = range.s.r; row <= range.e.r; row++) {
            for (var col = range.s.c; col <= range.e.c; col++) {
                var cellAddress = { r: row, c: col };
                var cellRef = XLSX.utils.encode_cell(cellAddress);
                if (!worksheet[cellRef])
                    worksheet[cellRef] = {}; // Create cell if not present
                // Initialize the cell style if it doesn't exist
                worksheet[cellRef].s = worksheet[cellRef].s || {};
                worksheet[cellRef].s.border = {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } }
                };
            }
        }
        var workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Comparison');
        var excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        var blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        var now = new Date();
        var timestamp = "" + now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0') + String(now.getSeconds()).padStart(2, '0');
        FileSaver.saveAs(blob, "ComparisonExported_" + timestamp + ".xlsx");
    };
    return ComparisonComponent;
}());
export { ComparisonComponent };
